const locationImageSlider = document.querySelectorAll('[data-slider="location-image-slider"]');

const locationImageSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  speed: 800,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

locationImageSlider.forEach((el) => {
  const parentElem = el.closest('.location-card');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');
  const pagination = parentElem.querySelector('.swiper-pagination');

  locationImageSliderOptions.navigation.prevEl = arrowLeft;
  locationImageSliderOptions.navigation.nextEl = arrowRight;
  locationImageSliderOptions.pagination.el = pagination;

  new Swiper(el, locationImageSliderOptions);
});

// Toggle Content
attachEvent('.location-card__read-more .link-with-arrow', 'click', (e) => {
  const parentElem = e.target.closest('.location-card');
  const content = parentElem.querySelector('.location-card__hidden-content');
  parentElem.classList.toggle('is-open');
  slideToggle(content, 300, 'block');

  setTimeout(() => {
    const locationCardTop = parentElem.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: locationCardTop - getHeaderHeight(), behavior: 'smooth' });
  }, 300);
});
